import { createI18n } from 'vue-i18n';
import {
	DEFAULT_LOCALE,
	normalizeLocale,
	resolveInitialLocale,
	saveLocale,
	setDocumentLocale
} from '@/utils/locale';
import zh from './zh';
import vi from './vi';

export const messages = {
	zh,
	vi
};

export const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: resolveInitialLocale(),
	fallbackLocale: DEFAULT_LOCALE,
	messages
});

export function getCurrentLocale() {
	return normalizeLocale(i18n.global.locale.value) || DEFAULT_LOCALE;
}

export function setLocale(locale) {
	const nextLocale = normalizeLocale(locale) || DEFAULT_LOCALE;
	i18n.global.locale.value = nextLocale;

	saveLocale(nextLocale);
	setDocumentLocale(nextLocale);

	return nextLocale;
}

setDocumentLocale(getCurrentLocale());
